import { Parameter } from '../interfaces/parameter.interface';
import { capitalize } from './capitalize.constant';

export const EnumToData = (enumType: any) => {
    const map: Parameter[] = [];

    for ( const attribute in enumType ) {
        if ( !enumType[attribute] ) {
            continue;
        }
        map.push({ id: enumType[attribute], name: capitalize(attribute?.toLowerCase()) });
    }
    return map;
};

